// extracted by mini-css-extract-plugin
export default {"wrapper":"header_wrapper__jzcN0","left":"header_left__V-v4x","right":"header_right__WH8rZ","smallButton":"header_smallButton__mMi3j","smallIcon":"header_smallIcon__KXCM3"};